import type {PinIdentifier} from '../../../types';
import type {AvailablePin} from '../../types';

import {Loading} from '@ds/components';

import AvailablePinItem from './components/AvailablePinItem/AvailablePinItem';

type AvailablePinsProps = {
  pins: AvailablePin[];
  selectedPins: PinIdentifier[];
  loading: boolean;
  onToggle: (pinId: PinIdentifier) => void;
};

const AvailablePins: React.FC<AvailablePinsProps> = ({pins, selectedPins, loading, onToggle}) => {
  if (loading) {
    return (
      <div className="flex min-h-32 flex-1 items-center justify-center">
        <Loading size="medium" color="primary" />
      </div>
    );
  }

  return (
    <section className="flex flex-col p-2.5">
      <h2 className="text-subtitle-md text-neutral-fg">بسته‌های رتبه دوم</h2>
      <p className="mt-1 text-body-sm text-gray-06">
        بسته‌های مورد نظر خود را برای خرید انتخاب کنید
      </p>
      <div className="mb-15 mt-2.5 flex flex-col">
        {pins.map((pin) => (
          <AvailablePinItem
            key={pin.available_pin_id}
            item={pin}
            selectedPins={selectedPins}
            onToggle={onToggle}
          />
        ))}
      </div>
    </section>
  );
};

export default AvailablePins;
